import type { FaireProductEntity } from "../../entity_types/product";

export const p_sq4hgphaqp: FaireProductEntity = {
  token: "p_sq4hgphaqp",
  type: "product",
  name: "Fun Doh Sports Dumpling Squishy Fidget Toy - 12/Display",
  brandToken: "b_bsd2pg2itm",
  brandName: "Novelty Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/0c689f9d76b8937a4244b8e1ec4a1904085dda7251305091098d6d085d5094c3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6e05bcce80c448e19057d19010ca0c7b400091f095d7d9aa9d80a840b2f41435.png",
    "https://cdn.faire.com/fastly/25dd5efa8e278105a681761003d47da237a3d60876595672eded70cc06761611.png",
    "https://cdn.faire.com/fastly/1aa1d16d6df30c2ed0835a168e20e0e99bdd8a11560ed6405340dacf3d2bc5d5.png",
    "https://cdn.faire.com/fastly/4c24322100920e7b125d8d76127ef705bf284596379c5497d1cc2048682aed79.png",
    "https://cdn.faire.com/fastly/b024cf9525e899b9a14a37e63e311f695c76dbed77346b1caf0fa071ac745f08.png",
    "https://cdn.faire.com/fastly/2da97fb2670bf8f05220913eabd28d8acbb5e9bbb85597d592fcafcccdc5b56a.png",
    "https://cdn.faire.com/fastly/fd8e54af2aa612b86d123539dbb3a4a439c0b2073e8a02925cbc7a0bdc06f2d5.png",
    "https://cdn.faire.com/fastly/dac396242c5e04c6cab9a69c76eda7381d0dedf34ba09ec0b853a4256addcea9.png",
    "https://cdn.faire.com/fastly/7d01195bf39ed32c39c2398bf00a5227d747bd93c631efdf26445a88b0a81454.png",
    "https://cdn.faire.com/fastly/129a405df22ca535c276ffc12d631cac6412533e70ea51c3c9ada895fa3ebaf7.png",
    "https://cdn.faire.com/fastly/952c90d07b98aa0ec278f88e8ef38b38c6fc825e1c9ddb9f13968bc2464e5a0f.png",
  ],
  priceDollars: 6,
  description:
    'Squeeze, squish, and smile! These adorable sports dumplings are the ultimate collectible squishy toys designed to bring joy to every squeeze. Each dumpling features a unique, vibrant sports theme, making them highly coveted items for trading with friends and building the ultimate collection.\n\nCrafted from premium, ultra-soft material, these dumplings offer an endlessly satisfying tactile experience. They are ideal for stress relief, fidgeting, and sensory play, making them a hit for both kids and teens looking for a fun way to unwind.\n\nHigh Collectibility: The sports-themed mystery element encourages repeat purchases as customers try to collect the whole set.\n\nSocial & Trend-Driven: Great for trading games and highly shareable on social media platforms like TikTok and Instagram.\n\nProduct Specifications\nMaterial: Premium, non-toxic, slow-rise polyurethane foam\nDimensions: Approximately 2.5" x 2.5" (perfect for small hands and on-the-go play)\nRecommended Age: 3+\n\nWHOLESALE BULK ITEM',
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:32.587Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
